<template>
  <div id="app">
    <Header/>
    <main>
      <transition mode="out-in">
        <router-view/>
      </transition>
    </main>
  </div>
</template>

<script>
import Header from '@/components/molecules/Header'

export default {
  name: 'App',
  components: {
    Header
  }
}
</script>

<style lang='scss'>
@import "@/styles/app.scss";
</style>
